if (!customElements.get('percept-footer-group')) {
  customElements.define('percept-footer-group', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.desktop = window.matchMedia('(min-width: 750px)');
      this.syncLayout = () => {
        this.details.open = this.desktop.matches;
        if (this.desktop.matches) {
          this.summary.setAttribute('tabindex', '-1');
          this.summary.setAttribute('aria-disabled', 'true');
        } else {
          this.summary.removeAttribute('tabindex');
          this.summary.removeAttribute('aria-disabled');
        }
      };
      this.preventDesktopToggle = event => {
        if (this.desktop.matches) event.preventDefault();
      };
      this.summary.addEventListener('click', this.preventDesktopToggle);
      this.desktop.addEventListener('change', this.syncLayout);
      this.syncLayout();
    }
    disconnectedCallback() {
      this.summary.removeEventListener('click', this.preventDesktopToggle);
      this.desktop.removeEventListener('change', this.syncLayout);
    }
  });
}

if (!customElements.get('percept-footer-localization')) {
  customElements.define('percept-footer-localization', class extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      this.form = this.querySelector('form');
      if (!this.select || !this.form) return;
      this.fitLabel = () => {
        if (!this.isConnected) return;
        const context = document.createElement('canvas').getContext('2d');
        if (!context) return;
        const style = window.getComputedStyle(this.select);
        context.font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
        const label = this.select.selectedOptions[0].textContent;
        this.select.style.width = `${Math.ceil(context.measureText(label).width) + 40}px`;
      };
      this.applyCountry = () => {
        this.fitLabel();
        // Shopify CLI's local proxy can reject POST /localization with 401.
        // Country context on the current URL works without leaving the preview.
        if (['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname)) {
          const url = new URL(window.location.href);
          url.searchParams.set('country', this.select.value);
          window.location.assign(url.toString());
          return;
        }
        this.form.requestSubmit();
      };
      this.select.addEventListener('change', this.applyCountry);
      this.setAttribute('data-auto-submit', '');
      this.fitLabel();
      if (document.fonts) document.fonts.ready.then(this.fitLabel);
    }
    disconnectedCallback() {
      if (this.select) this.select.removeEventListener('change', this.applyCountry);
    }
  });
}
